import { setListener } from '@front/utils';
import { createComponent } from '@front/utils/alpine';

export default createComponent(() => ({
    init() {
        const password = document.querySelector(
            '.js-password-create'
        ) as HTMLInputElement;

        setListener(password, 'keyup', () => {
            if (password.value.length < 5 && password.value.length > 0) {
                this.$refs.strength.style.width = '33%';
                this.$refs.strength.style.backgroundColor = '#f3283d';
                this.$refs.weak.classList.remove('hidden');
                this.$refs.medium.classList.add('hidden');
                this.$refs.strong.classList.add('hidden');
                this.$refs.text.classList.remove('hidden');
            } else if (
                password.value.length >= 5 &&
                password.value.length < 8
            ) {
                this.$refs.strength.style.width = '66%';
                this.$refs.strength.style.backgroundColor = '#fc0';
                this.$refs.weak.classList.add('hidden');
                this.$refs.medium.classList.remove('hidden');
                this.$refs.strong.classList.add('hidden');
                this.$refs.text.classList.remove('hidden');
            } else if (password.value.length >= 8) {
                this.$refs.strength.style.width = '100%';
                this.$refs.strength.style.backgroundColor = '#38B24E';
                this.$refs.weak.classList.add('hidden');
                this.$refs.medium.classList.add('hidden');
                this.$refs.strong.classList.remove('hidden');
                this.$refs.text.classList.remove('hidden');
            } else if (password.value.length == 0) {
                this.$refs.strength.style.width = '0%';
                this.$refs.strength.style.backgroundColor = '#f3283d';
                this.$refs.weak.classList.add('hidden');
                this.$refs.medium.classList.add('hidden');
                this.$refs.strong.classList.add('hidden');
                this.$refs.text.classList.add('hidden');
            }
        });
    },
}));
